import { Keyboard, Mic, MicOff } from 'lucide-react';

import { Button } from '../../../lib/button';
import { cn } from '../../../lib/utils';
import { ButtonsFunctionalProps } from '../types';
import MicAnalyser from './MicAnalyser';

const ButtonsFunctional: React.FC<ButtonsFunctionalProps> = ({
    ongoingCall,
    showKeys,
    setShowKeys,
    isMuted,
    toggleMuteMicrophone
}) => {
    const { call, type } = ongoingCall || {};
    const callStatus = call?.status();
    const micBtnVariant = isMuted ? 'destructive' : 'outline-dark';
    const keysBtnClass = cn('p-0 w-10', showKeys && 'bg-white text-black hover:bg-gray-300');

    return (
        <div className="flex gap-2">
            {callStatus && (
                <>
                    <MicAnalyser call={call} />
                    <Button variant={micBtnVariant} className="p-0 w-10" onClick={toggleMuteMicrophone}>
                        {isMuted ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
                    </Button>
                    {type === 'outgoing' && (
                        <Button variant="outline-dark" className={keysBtnClass} onClick={() => setShowKeys(!showKeys)}>
                            <Keyboard className="h-5 w-5" />
                        </Button>
                    )}
                </>
            )}
        </div>
    );
};
export default ButtonsFunctional;
